import type { Dayjs } from 'dayjs'
import fi from 'dayjs/locale/fi'

interface ICustomLocale extends Omit<ILocale, 'monthsShort' | 'weekdaysShort'> {
  weekdaysShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
  monthsShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
}

const locale: ICustomLocale = {
  ...fi,
  name: 'fi',
  weekStart: 1,
  weekdaysShort: (dayjsInstance: Dayjs, format: string): string => {
    const extended = 'Su_Ma_Ti_Ke_To_Pe_La'.split('_')
    const standard = 'su_ma_ti_ke_to_pe_la'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.day()]
    } else {
      return standard[dayjsInstance.day()]
    }
  },
  monthsShort: (dayjsInstance: Dayjs, format: string): string => {
    const extended = 'Tammi_Helmi_Maalis_Huhti_Touko_Kesä_Heinä_Elo_Syys_Loka_Marras_Joulu'.split('_')
    const standard = 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.month()]
    } else {
      return standard[dayjsInstance.month()]
    }
  }
}

export default locale
